// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file finance/v1/finance.proto (package finance.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file finance/v1/finance.proto.
 */
export const file_finance_v1_finance: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message finance.v1.PaymentStatus
 */
export type PaymentStatus = Message<"finance.v1.PaymentStatus"> & {
  /**
   * @generated from field: finance.v1.PaymentStatus.Status status = 1;
   */
  status: PaymentStatus_Status;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message finance.v1.PaymentStatus.
 * Use `create(PaymentStatusSchema)` to create a new message.
 */
export const PaymentStatusSchema: GenMessage<PaymentStatus> = /*@__PURE__*/
  messageDesc(file_finance_v1_finance, 0);

/**
 * @generated from enum finance.v1.PaymentStatus.Status
 */
export enum PaymentStatus_Status {
  /**
   * @generated from enum value: STATUS_PAYMENT_STATUS_UNSPECIFIED = 0;
   */
  PAYMENT_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATUS_PAYMENT_STATUS_PENDING = 1;
   */
  PAYMENT_STATUS_PENDING = 1,

  /**
   * @generated from enum value: STATUS_PAYMENT_STATUS_PROCESSING = 2;
   */
  PAYMENT_STATUS_PROCESSING = 2,

  /**
   * @generated from enum value: STATUS_PAYMENT_STATUS_COMPLETED = 3;
   */
  PAYMENT_STATUS_COMPLETED = 3,

  /**
   * @generated from enum value: STATUS_PAYMENT_STATUS_FAILED = 4;
   */
  PAYMENT_STATUS_FAILED = 4,

  /**
   * @generated from enum value: STATUS_PAYMENT_STATUS_CANCELLED = 5;
   */
  PAYMENT_STATUS_CANCELLED = 5,
}

/**
 * Describes the enum finance.v1.PaymentStatus.Status.
 */
export const PaymentStatus_StatusSchema: GenEnum<PaymentStatus_Status> = /*@__PURE__*/
  enumDesc(file_finance_v1_finance, 0, 0);

/**
 * @generated from message finance.v1.DocumentStatus
 */
export type DocumentStatus = Message<"finance.v1.DocumentStatus"> & {
  /**
   * @generated from field: finance.v1.DocumentStatus.Status status = 1;
   */
  status: DocumentStatus_Status;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message finance.v1.DocumentStatus.
 * Use `create(DocumentStatusSchema)` to create a new message.
 */
export const DocumentStatusSchema: GenMessage<DocumentStatus> = /*@__PURE__*/
  messageDesc(file_finance_v1_finance, 1);

/**
 * @generated from enum finance.v1.DocumentStatus.Status
 */
export enum DocumentStatus_Status {
  /**
   * @generated from enum value: STATUS_DOCUMENT_STATUS_UNSPECIFIED = 0;
   */
  DOCUMENT_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATUS_DOCUMENT_STATUS_DRAFT = 1;
   */
  DOCUMENT_STATUS_DRAFT = 1,

  /**
   * @generated from enum value: STATUS_DOCUMENT_STATUS_PENDING = 2;
   */
  DOCUMENT_STATUS_PENDING = 2,

  /**
   * @generated from enum value: STATUS_DOCUMENT_STATUS_APPROVED = 3;
   */
  DOCUMENT_STATUS_APPROVED = 3,

  /**
   * @generated from enum value: STATUS_DOCUMENT_STATUS_REJECTED = 4;
   */
  DOCUMENT_STATUS_REJECTED = 4,

  /**
   * @generated from enum value: STATUS_DOCUMENT_STATUS_VOID = 5;
   */
  DOCUMENT_STATUS_VOID = 5,
}

/**
 * Describes the enum finance.v1.DocumentStatus.Status.
 */
export const DocumentStatus_StatusSchema: GenEnum<DocumentStatus_Status> = /*@__PURE__*/
  enumDesc(file_finance_v1_finance, 1, 0);

/**
 * @generated from enum finance.v1.PaymentTermCode
 */
export enum PaymentTermCode {
  /**
   * @generated from enum value: PAYMENT_TERM_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_CAD = 1;
   */
  CAD = 1,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_CIA = 2;
   */
  CIA = 2,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_CND = 3;
   */
  CND = 3,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_COD = 4;
   */
  COD = 4,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_EOM = 5;
   */
  EOM = 5,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_LOC = 6;
   */
  LOC = 6,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_NET5 = 7;
   */
  NET5 = 7,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_NET10 = 8;
   */
  NET10 = 8,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_NET15 = 9;
   */
  NET15 = 9,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_NET20 = 10;
   */
  NET20 = 10,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_NET30 = 11;
   */
  NET30 = 11,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_NET45 = 12;
   */
  NET45 = 12,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_NET60 = 13;
   */
  NET60 = 13,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_NET90 = 14;
   */
  NET90 = 14,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_PIA = 15;
   */
  PIA = 15,

  /**
   * @generated from enum value: PAYMENT_TERM_CODE_DUE_UPON_RECEIPT = 16;
   */
  DUE_UPON_RECEIPT = 16,
}

/**
 * Describes the enum finance.v1.PaymentTermCode.
 */
export const PaymentTermCodeSchema: GenEnum<PaymentTermCode> = /*@__PURE__*/
  enumDesc(file_finance_v1_finance, 0);

/**
 * @generated from enum finance.v1.PaymentMethod
 */
export enum PaymentMethod {
  /**
   * @generated from enum value: PAYMENT_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_METHOD_CASH = 1;
   */
  CASH = 1,

  /**
   * @generated from enum value: PAYMENT_METHOD_CHECK = 2;
   */
  CHECK = 2,

  /**
   * @generated from enum value: PAYMENT_METHOD_ACH = 3;
   */
  ACH = 3,

  /**
   * @generated from enum value: PAYMENT_METHOD_ATM = 4;
   */
  ATM = 4,

  /**
   * @generated from enum value: PAYMENT_METHOD_WIRE = 5;
   */
  WIRE = 5,

  /**
   * @generated from enum value: PAYMENT_METHOD_WRITE_OFF = 6;
   */
  WRITE_OFF = 6,
}

/**
 * Describes the enum finance.v1.PaymentMethod.
 */
export const PaymentMethodSchema: GenEnum<PaymentMethod> = /*@__PURE__*/
  enumDesc(file_finance_v1_finance, 1);

/**
 * @generated from enum finance.v1.PaymentType
 */
export enum PaymentType {
  /**
   * @generated from enum value: PAYMENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_TYPE_BILL = 1;
   */
  BILL = 1,

  /**
   * @generated from enum value: PAYMENT_TYPE_INVOICE = 2;
   */
  INVOICE = 2,

  /**
   * @generated from enum value: PAYMENT_TYPE_NETTING = 3;
   */
  NETTING = 3,

  /**
   * @generated from enum value: PAYMENT_TYPE_ADJUSTMENT = 4;
   */
  ADJUSTMENT = 4,

  /**
   * @generated from enum value: PAYMENT_TYPE_ADVANCE_IN = 5;
   */
  ADVANCE_IN = 5,

  /**
   * @generated from enum value: PAYMENT_TYPE_ADVANCE_OUT = 6;
   */
  ADVANCE_OUT = 6,

  /**
   * @generated from enum value: PAYMENT_TYPE_WRITE_OFF = 7;
   */
  WRITE_OFF = 7,
}

/**
 * Describes the enum finance.v1.PaymentType.
 */
export const PaymentTypeSchema: GenEnum<PaymentType> = /*@__PURE__*/
  enumDesc(file_finance_v1_finance, 2);

